import React from 'react';
import { Route } from 'react-router-dom';
import * as ROUTES from '../constants/routes';
import Empty from '../components/Empty.jsx';
import { loadingContent } from '../components/EmptyStates.jsx';
import ErrorPage from '../pages/_error';
import NotFoundPage from '../pages/_not-found';
import AIAssistant from '../pages/ai-assistant';

const ThankYou = React.lazy(() => import('../pages/thank-you'));
const OnlineEvents = React.lazy(() => import('../pages/online-events'));

export const otherRoutes = () => (
  <>
    <Route
      path={ROUTES.THANK_YOU}
      element={
        <React.Suspense
          fallback={<Empty simplified content={loadingContent} />}
        >
          <ThankYou />
        </React.Suspense>
      }
    />
    <Route
      path={ROUTES.ONLINE_EVENTS}
      element={
        <React.Suspense
          fallback={<Empty simplified content={loadingContent} />}
        >
          <OnlineEvents />
        </React.Suspense>
      }
    />
    <Route path={ROUTES.AI_ASSISTANT} element={<AIAssistant />} />

    {/* Error / 404 */}
    <Route path={ROUTES.NOT_FOUND} element={<NotFoundPage />} />
    <Route path="*" element={<ErrorPage />} />
  </>
);
